import React, { useRef, useState } from "react";
import { FormattedMessage } from "react-intl";
import { AutoComplete } from "antd";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import numeral from "numeral";
import FilterDeadlinesChips from "./filterDeadlinesChips";

const DocumentAmountFilter = ({filterCounter, setFilterCounter, selectedDocumentAmountsToShow,
  setSelectedDocumentAmountsToShow, selectedDocumentAmounts, setSelectedDocumentAmounts}) => {

  const [documentAmountOptions, setDocumentAmountOptions] = useState([]);
  const [documentAmountValue, setDocumentAmountValue] = useState("");
  const reconcilableDeadlines = useSelector(state => state.reconciliation.operations.reconcilableDeadlines);

  useEffect(() => {
    const documentsAmountsRaw = reconcilableDeadlines?.filteredDeadlines?.map(d => {
      return (`${numeral(Math.abs(d.totalAmount)).format("0,0.00")} €`);
    });
    const uniqDocumentsAmounts = [...new Set(documentsAmountsRaw)];
    const documentsAmounts = uniqDocumentsAmounts.map((am, index) => {
      return ({
        value: am,
        index: index
      });
    });
    setDocumentAmountOptions(documentsAmounts);
  }, [reconcilableDeadlines]);

  const refDocumentAmount = useRef();

  const onChangeDocumentAmount = (
    e, isToAddInChips, completeEl
  ) => {
    setDocumentAmountValue(e);

    if (e && isToAddInChips) {
      if (selectedDocumentAmountsToShow.length === 0) {
        setFilterCounter(filterCounter + 1);
      }
      if (!selectedDocumentAmountsToShow.includes(e)) {
        const selectedDocCopy = [...selectedDocumentAmountsToShow];
        selectedDocCopy.push(e);
        setDocumentAmountValue("");
        setSelectedDocumentAmountsToShow(selectedDocCopy);
      }

      const totalAmounts = reconcilableDeadlines?.filteredDeadlines?.map(d => d.totalAmount);
      const uniqFilteredAmounts = [...new Set(totalAmounts)];

      const selectedAmount = uniqFilteredAmounts?.find((d, index) => {
        if (completeEl?.index === index) {
          return d;
        } 
        return null;
        
      });

      if (!selectedDocumentAmounts.includes(selectedAmount)) {
        const selectedDocAmCopy = [...selectedDocumentAmounts];
        selectedDocAmCopy.push(selectedAmount);
        setSelectedDocumentAmounts(selectedDocAmCopy);
      }
    }
  };

  const removeDocumentAmounts = index => {
    const selectedDocCopy = [...selectedDocumentAmountsToShow];
    selectedDocCopy.splice(index, 1);
    setSelectedDocumentAmountsToShow(selectedDocCopy);

    const selectedDocAmCopy = [...selectedDocumentAmounts];
    selectedDocAmCopy.splice(index, 1);
    setSelectedDocumentAmounts(selectedDocAmCopy);
  };

  const renderDocumentAmountsChips = () => {
    return (
      <FilterDeadlinesChips
        selectedItems={selectedDocumentAmountsToShow}
        onRemoveSelectedItems={index => removeDocumentAmounts(index)}
        key={"docNumber"}
      />
    );
  };

  return (
    <>
      <div className="document-amount-filter-container">
			  <h4 className="document-amount-title"><FormattedMessage id="generic.documentAmount"/></h4>
			  <AutoComplete
			    ref={refDocumentAmount}
			    allowClear={true}
			    popoverPlacement={"bottom"}
			    getPopupContainer={trigger => trigger.parentNode}
          options={documentAmountOptions}
			    style={{ width: "100%"}}
			    initialValue={documentAmountValue}
			    value={documentAmountValue}
			    filterOption={(inputValue, option) => {
			      if (inputValue === "") return true;
			      return option.value.indexOf(inputValue.toUpperCase())>-1;
			    }
			    }
			    placeholder={""}
			    notFoundContent={"Nessun risultato"}
			    onClear={()=> {
			      onChangeDocumentAmount("", false);
			      refDocumentAmount.current.focus();
			    }}
			    onSearch={el => {
			      onChangeDocumentAmount(el, false);
			    }}
			    onSelect={(el, completeEl) => {
			      onChangeDocumentAmount(
              el, true, completeEl
            );
			      refDocumentAmount.current.blur();
			    }}
			  />
			  {renderDocumentAmountsChips()}
      </div>
   	</>
  );
};

export default DocumentAmountFilter;

